import { render, staticRenderFns } from "./BoxList.vue?vue&type=template&id=20ca3d76&scoped=true&"
import script from "./BoxList.vue?vue&type=script&lang=js&"
export * from "./BoxList.vue?vue&type=script&lang=js&"
import style0 from "./BoxList.vue?vue&type=style&index=0&id=20ca3d76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ca3d76",
  null
  
)

export default component.exports